<script>
  import { Card, CardCoverImage, CardContent } from '../../components/Card'

  export let entry

  $: coverImageOverlay = entry.images ? `+${entry.images.length - 1}` : ''
</script>

<Card clickable on:click orientation='landscape'>
  {#if entry.coverImage}
    <div class="cover-image">
      <CardCoverImage image={entry.coverImage} overlay={coverImageOverlay} />
    </div>
  {/if}

  <div class="content-wrapper">
    <CardContent>
      <h2 class="h3">{entry.title}</h2>
      {#if entry.content}
        <p>
          {entry.contentPreview(72)}
        </p>
      {/if}
    </CardContent>
  </div>
</Card>

<style>
.cover-image {
  min-height: 0;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--card-content-padding);
}

:global(.portrait) .cover-image {
  min-height: 25%;
}

:global(.portrait) .content-wrapper {
  padding-top: var(--card-content-padding);
}

:global(.landscape) .cover-image {
  flex-basis: 25%;
  flex-grow: 0;
  flex-shrink: 0;
  height: 100%;
}

:global(.landscape) .content-wrapper {
  padding-top: var(--card-content-padding);
  padding-bottom: var(--card-content-padding);
}
</style>
